import React, { ReactNode, useContext, useEffect, useState } from 'react';

import ProfitabilityContext from '@totem/components/ticketing/details/profitability/profitabilityContext';
import { ProfitabilityItem } from '@totem/components/ticketing/details/profitability/types';
import TicketContext from '@totem/components/ticketing/details/ticketContext';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { TICKET_ENDPOINT } from '@totem/utilities/endpoints';
type Props = {
  ticketId: string;
  children?: ReactNode;
};
const ProfitabilityContainer = ({ ticketId, children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [profitabilityData, setProfitabilityData] =
    useState<ProfitabilityItem>(null);
  const { ticket } = useContext(TicketContext);

  useEffect(() => {
    fetch(`${TICKET_ENDPOINT}/${ticketId}/profitability`, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => res.json())
      .then((result: ProfitabilityItem) => {
        setProfitabilityData(result);
      })
      .then(() => setIsLoading(false));
  }, [ticketId, ticket, getApiToken]);

  return (
    <ProfitabilityContext.Provider
      value={{
        loading: isLoading,
        data: profitabilityData,
      }}
    >
      {children}
    </ProfitabilityContext.Provider>
  );
};
export default ProfitabilityContainer;
